export const formatHoursToTime = (hours: number): string => {
    const wholeHours = Math.floor(hours);
    const decimalPart = hours - wholeHours;
    const minutes = Math.round(decimalPart * 60);
    if (minutes === 60) {
        return `${wholeHours + 1}:00`;
    }

    return `${wholeHours}:${String(minutes).padStart(2, "0")}`;
};
